<app-modal-container
  data-qa="kpi-cross-company-chart-modal"
  [bigSize]="true"
  [titleDirection]="'start'"
  [title]="title"
  [titleStyles]="'max-w-none'"
  [buttons]="{ close: true }"
  (closeButtonClicked)="close()">
  @if(isLoading) {
    <app-empty-chart class="w-[50rem] h-[28rem]" [circle]="false" [description]="'Loading'"></app-empty-chart>
  }
  @else {
    <app-base-bar-chart
      class="w-[50rem]"
      [chartId]="'kpi-cross-company-chart'"
      [additionalOptions]="options">
    </app-base-bar-chart>
  }
</app-modal-container>
